import styled from 'styled-components';

export const AlternateDates = styled.div(props => `
    padding: 14px 40px;
    border-radius: 8px;
    background-color: #ffffff;
    margin-top: 16px;
    display: flex;
    align-items: center;
    .altrntDatesHeading {
        color: ${props.theme ? props.theme.colors.downriver.base : '#141823'};
        font-family: ${props.theme && props.theme.font.fontFamily};
        font-size: ${props.theme && props.theme.font.custom(28)};
        font-weight: bold;
        margin-bottom: 2px;
    }
    .altrntDatesSubHeading {
        font-family: 'roboto';
        line-height: 22px;
        font-size: 1.6rem;
        color: ${props.theme ? props.theme.colors.downriver.base : '#141823'};
    }
    ul {
        flex: 1;
        display: flex;
        align-items: center;
        margin-left: 75px;
        overflow-y: auto;
        padding: 10px 0 10px 5px;
        li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 220px;
            padding: 12px 38px;
            border-radius: 9.1px;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
            background-color: #ffffff;
            margin-right: 17px;
            cursor: pointer;
            &:last-child {
                margin-right: 0px;
            }
            p:first-child {
                font-family: Quicksand;
                font-size: 2.3rem;
                font-weight: bold;
                color: #2274e0;
                line-height: 1.33;
            }
            p:last-child {
                font-family: Roboto;
                font-size: 1.6rem;
                color: ${props.theme ? props.theme.colors.downriver.medium : '#777'};
            }
            &.disabled {
                background-color: #f3f3f3;
                p:first-child {
                    color: ${props.theme ? props.theme.colors.downriver.dark : '#46484d'};
                }
            }
        }
    }
`);
